export const enhancementOptionsList = (t) => [
  {
    value: "professional",
    label: t("photoEnhancement.professional"),
  },
  {
    value: "vivid",
    label: t("photoEnhancement.vivid"),
  },
  {
    value: "vintage",
    label: t("photoEnhancement.vintage"),
  },
  {
    value: "lowlight",
    label: t("photoEnhancement.lowlight"),
  },
  {
    value: "portrait",
    label: t("photoEnhancement.portrait"),
  },
  {
    value: "product",
    label: t("photoEnhancement.product"),
  },
  {
    value: "cinematic",
    label: t("photoEnhancement.cinematic"),
  },
  {
    value: "hdr",
    label: t("photoEnhancement.hdr"),
  },
  {
    value: "matte",
    label: t("photoEnhancement.matte"),
  },
  {
    value: "soft",
    label: t("photoEnhancement.soft"),
  },
  {
    value: "blackandwhite",
    label: t("photoEnhancement.blackandwhite"),
  },
  {
    value: "custom",
    label: t("photoEnhancement.custom"),
  },
];
